"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsManager = void 0;
var EventsManager = (function () {
    function EventsManager() {
        var _this = this;
        this.eventListeners = {};
        this.addEventListener = function (eventName, listener) {
            if (!_this.eventListeners[eventName])
                _this.eventListeners[eventName] = [];
            var listeners = _this.eventListeners[eventName];
            listeners.push(listener);
        };
        this.removeEventListener = function (eventName, listener) {
            var listeners = _this.eventListeners[eventName];
            if (!listeners)
                return;
            var index = listeners.indexOf(listener);
            if (index !== -1)
                listeners.splice(index, 1);
        };
        this.triggerEvent = function (eventName, payload) {
            var eventListeners = _this.eventListeners[eventName];
            if (!eventListeners)
                return;
            var listeners = eventListeners.map(function (l) { return l; });
            listeners.forEach(function (listener) { return listener(payload); });
        };
    }
    return EventsManager;
}());
exports.EventsManager = EventsManager;
//# sourceMappingURL=index.js.map